module.exports = __webpack_public_path__ + "static/quad-img-1-a94af09e11de9c18b54e79e5e539404d.jpg";